/**
 * NWT_Core_Services
 * <h1>NWT_Core_Services</h1>
 *
 * OpenAPI spec version:
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { JsonBaseResponseDTO } from '../model/jsonBaseResponseDTO';
import { JsonHierarchyBounds } from '../model/jsonHierarchyBounds';
import { JsonHierarchyCounts } from '../model/jsonHierarchyCounts';
import { JsonHierarchyElement } from '../model/jsonHierarchyElement';
import { JsonNodeTroubleCall } from '../model/jsonNodeTroubleCall';
import { JsonStormModeHierarchySettings } from '../model/jsonStormModeHierarchySettings';

import { NWT_BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class NetworkHierarchyServiceResourceService {

    protected basePath = 'https://localhost/corejson';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(NWT_BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Returns a hierarchy tree with just names and id&#39;s.
     * Returns a hierarchy tree with just names and id&#39;s
     * @param cmts
     * @param nodeName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceGetFbcHierarchySettingByNodeCmtsGET(cmts?: string, nodeName?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public resourceNetworkHierarchyServiceResourceGetFbcHierarchySettingByNodeCmtsGET(cmts?: string, nodeName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public resourceNetworkHierarchyServiceResourceGetFbcHierarchySettingByNodeCmtsGET(cmts?: string, nodeName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public resourceNetworkHierarchyServiceResourceGetFbcHierarchySettingByNodeCmtsGET(cmts?: string, nodeName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cmts !== undefined) {
            queryParameters = queryParameters.set('cmts', <any>cmts);
        }
        if (nodeName !== undefined) {
            queryParameters = queryParameters.set('nodeName', <any>nodeName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json',
            'text/plain'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<number>(`${this.basePath}/networkHierarchyService/getFbcHierarchySettingByNodeCmts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This method returns the Hierarchy bounds for a network hierarchy id supplied.
     * This method returns the Hierarchy bounds for a network hierarchy id supplied
     * @param networkHierarchyId is in long format
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceGetHierarchyBoundsGET(networkHierarchyId?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonHierarchyBounds>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyBoundsGET(networkHierarchyId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonHierarchyBounds>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyBoundsGET(networkHierarchyId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonHierarchyBounds>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyBoundsGET(networkHierarchyId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (networkHierarchyId !== undefined) {
            queryParameters = queryParameters.set('networkHierarchyId', <any>networkHierarchyId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonHierarchyBounds>(`${this.basePath}/networkHierarchyService/getHierarchyBounds`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param rootid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceGetHierarchyChildrenElementsGET(rootid?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonHierarchyElement>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyChildrenElementsGET(rootid?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonHierarchyElement>>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyChildrenElementsGET(rootid?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonHierarchyElement>>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyChildrenElementsGET(rootid?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rootid !== undefined) {
            queryParameters = queryParameters.set('rootid', <any>rootid);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonHierarchyElement>>(`${this.basePath}/networkHierarchyService/getHierarchyChildren`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the counts associated with each element starting with the selected rootid.
     * Retrieves the counts associated with each element starting with the selected rootid.  This retrieves the list of CMTS&#39;s below the root id, and then sums the counts of various values for each entity that is part of the CMTS&#39;s group.
     * @param rootid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceGetHierarchyCountsGET(rootid?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonHierarchyCounts>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyCountsGET(rootid?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonHierarchyCounts>>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyCountsGET(rootid?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonHierarchyCounts>>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyCountsGET(rootid?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rootid !== undefined) {
            queryParameters = queryParameters.set('rootid', <any>rootid);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonHierarchyCounts>>(`${this.basePath}/networkHierarchyService/getHierarchyCounts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param maxAgeSeconds
     * @param rootid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceGetHierarchyElementGET(maxAgeSeconds?: number, rootid?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonHierarchyElement>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyElementGET(maxAgeSeconds?: number, rootid?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonHierarchyElement>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyElementGET(maxAgeSeconds?: number, rootid?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonHierarchyElement>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyElementGET(maxAgeSeconds?: number, rootid?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (maxAgeSeconds !== undefined) {
            queryParameters = queryParameters.set('maxAgeSeconds', <any>maxAgeSeconds);
        }
        if (rootid !== undefined) {
            queryParameters = queryParameters.set('rootid', <any>rootid);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonHierarchyElement>(`${this.basePath}/networkHierarchyService/getHierarchy`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns a hierarchy tree with just names and id&#39;s.
     * Returns a hierarchy tree with just names and id&#39;s
     * @param nodeId as network element id
     * @param rootId hierarchy id to start from
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceGetHierarchyNodeUpGET(nodeId?: number, rootId?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonHierarchyElement>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyNodeUpGET(nodeId?: number, rootId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonHierarchyElement>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyNodeUpGET(nodeId?: number, rootId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonHierarchyElement>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyNodeUpGET(nodeId?: number, rootId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nodeId !== undefined) {
            queryParameters = queryParameters.set('nodeId', <any>nodeId);
        }
        if (rootId !== undefined) {
            queryParameters = queryParameters.set('rootId', <any>rootId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonHierarchyElement>(`${this.basePath}/networkHierarchyService/getHierarchyNodeUp`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param hierId
     * @param sortValue
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceGetHierarchyTroubleCallsGET(hierId?: number, sortValue?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonNodeTroubleCall>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyTroubleCallsGET(hierId?: number, sortValue?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonNodeTroubleCall>>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyTroubleCallsGET(hierId?: number, sortValue?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonNodeTroubleCall>>>;
    public resourceNetworkHierarchyServiceResourceGetHierarchyTroubleCallsGET(hierId?: number, sortValue?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (hierId !== undefined) {
            queryParameters = queryParameters.set('hierId', <any>hierId);
        }
        if (sortValue !== undefined) {
            queryParameters = queryParameters.set('sortValue', <any>sortValue);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonNodeTroubleCall>>(`${this.basePath}/networkHierarchyService/getHierarchyTC`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param cmtsId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceGetNodeCountsGET(cmtsId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonHierarchyCounts>>;
    public resourceNetworkHierarchyServiceResourceGetNodeCountsGET(cmtsId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonHierarchyCounts>>>;
    public resourceNetworkHierarchyServiceResourceGetNodeCountsGET(cmtsId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonHierarchyCounts>>>;
    public resourceNetworkHierarchyServiceResourceGetNodeCountsGET(cmtsId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cmtsId !== undefined) {
            queryParameters = queryParameters.set('cmtsId', <any>cmtsId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonHierarchyCounts>>(`${this.basePath}/networkHierarchyService/getNodeCounts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns a hierarchy tree with just names and id&#39;s.
     * Returns a hierarchy tree with just names and id&#39;s
     * @param includeNodes should the response include nodes, true/false
     * @param maxAgeSeconds 0 skips cache check
     * @param maxlevels number of levels of the tree you want returned
     * @param rootid hierarchy id to start from
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceGetSimpleHierarchyElementGET(includeNodes?: boolean, maxAgeSeconds?: number, maxlevels?: number, rootid?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonHierarchyElement>;
    public resourceNetworkHierarchyServiceResourceGetSimpleHierarchyElementGET(includeNodes?: boolean, maxAgeSeconds?: number, maxlevels?: number, rootid?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonHierarchyElement>>;
    public resourceNetworkHierarchyServiceResourceGetSimpleHierarchyElementGET(includeNodes?: boolean, maxAgeSeconds?: number, maxlevels?: number, rootid?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonHierarchyElement>>;
    public resourceNetworkHierarchyServiceResourceGetSimpleHierarchyElementGET(includeNodes?: boolean, maxAgeSeconds?: number, maxlevels?: number, rootid?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (includeNodes !== undefined) {
            queryParameters = queryParameters.set('includeNodes', <any>includeNodes);
        }
        if (maxAgeSeconds !== undefined) {
            queryParameters = queryParameters.set('maxAgeSeconds', <any>maxAgeSeconds);
        }
        if (maxlevels !== undefined) {
            queryParameters = queryParameters.set('maxlevels', <any>maxlevels);
        }
        if (rootid !== undefined) {
            queryParameters = queryParameters.set('rootid', <any>rootid);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonHierarchyElement>(`${this.basePath}/networkHierarchyService/hierarchy`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Storm mode settings for a particular nhoId.
     * Get Storm mode settings for a particular nhoId
     * @param nhoId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceGetStormModeHierarchySettingsGET(nhoId?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonStormModeHierarchySettings>;
    public resourceNetworkHierarchyServiceResourceGetStormModeHierarchySettingsGET(nhoId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonStormModeHierarchySettings>>;
    public resourceNetworkHierarchyServiceResourceGetStormModeHierarchySettingsGET(nhoId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonStormModeHierarchySettings>>;
    public resourceNetworkHierarchyServiceResourceGetStormModeHierarchySettingsGET(nhoId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nhoId !== undefined) {
            queryParameters = queryParameters.set('nhoId', <any>nhoId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonStormModeHierarchySettings>(`${this.basePath}/networkHierarchyService/getStormModeHierarchySettings`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Admin function to run NCP Load All process.
     * Admin function to run NCP Load All process. The same as the servlet but with params
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceLoadNCPAllGET(observe?: 'body', reportProgress?: boolean): Observable<JsonBaseResponseDTO>;
    public resourceNetworkHierarchyServiceResourceLoadNCPAllGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonBaseResponseDTO>>;
    public resourceNetworkHierarchyServiceResourceLoadNCPAllGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonBaseResponseDTO>>;
    public resourceNetworkHierarchyServiceResourceLoadNCPAllGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json',
            'text/plain'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonBaseResponseDTO>(`${this.basePath}/networkHierarchyService/loadNCPAll`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Admin function to run Hierarchy Reconciler process.
     * Admin function to run Hierarchy Reconciler process. The same as the servlet but with params
     * @param force
     * @param recalclatlon
     * @param skipload
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceReconcileGET(force?: boolean, recalclatlon?: boolean, skipload?: boolean, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourceNetworkHierarchyServiceResourceReconcileGET(force?: boolean, recalclatlon?: boolean, skipload?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourceNetworkHierarchyServiceResourceReconcileGET(force?: boolean, recalclatlon?: boolean, skipload?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourceNetworkHierarchyServiceResourceReconcileGET(force?: boolean, recalclatlon?: boolean, skipload?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (force !== undefined) {
            queryParameters = queryParameters.set('force', <any>force);
        }
        if (recalclatlon !== undefined) {
            queryParameters = queryParameters.set('recalclatlon', <any>recalclatlon);
        }
        if (skipload !== undefined) {
            queryParameters = queryParameters.set('skipload', <any>skipload);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json',
            'text/plain'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/networkHierarchyService/reconcile`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceUpdateNodeAffinitiesGET(observe?: 'body', reportProgress?: boolean): Observable<Array<number>>;
    public resourceNetworkHierarchyServiceResourceUpdateNodeAffinitiesGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<number>>>;
    public resourceNetworkHierarchyServiceResourceUpdateNodeAffinitiesGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<number>>>;
    public resourceNetworkHierarchyServiceResourceUpdateNodeAffinitiesGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<number>>(`${this.basePath}/networkHierarchyService/updateNodeAffinities`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Allow update of the storm mode network hierarchy settings from a JSON object from a jQuery JS client call.
     * Allow update of the storm mode network hierarchy settings from a JSON object from a jQuery JS client call
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceUpdateStormModeHierarchySettingsPUT(body?: JsonStormModeHierarchySettings, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public resourceNetworkHierarchyServiceResourceUpdateStormModeHierarchySettingsPUT(body?: JsonStormModeHierarchySettings, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public resourceNetworkHierarchyServiceResourceUpdateStormModeHierarchySettingsPUT(body?: JsonStormModeHierarchySettings, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public resourceNetworkHierarchyServiceResourceUpdateStormModeHierarchySettingsPUT(body?: JsonStormModeHierarchySettings, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/networkHierarchyService/updateStormModeHierarchySettings`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNetworkHierarchyServiceResourceUpdateVcmtsGET(observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourceNetworkHierarchyServiceResourceUpdateVcmtsGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourceNetworkHierarchyServiceResourceUpdateVcmtsGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourceNetworkHierarchyServiceResourceUpdateVcmtsGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json',
            'text/plain'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/networkHierarchyService/updatevcmts`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
